var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "custom-class": "ai-trust-from-window",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.AssociationBusinessInformation"),
        "close-on-click-modal": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          _vm.innerVisible = false
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _vm.showRevokeButton
          ? _c(
              "div",
              { staticStyle: { "padding-bottom": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "revoke", type: "danger" },
                    on: { click: _vm.revokeJobHandler }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_WithdrawTheEntrustment"))
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            class:
              "tabs-container" +
              (_vm.canOperateJob ? "" : " cannot-operate-job")
          },
          [
            _c("span", { staticClass: "lab-state" }, [
              _vm._v(_vm._s(_vm.labState))
            ]),
            _c(
              "el-tabs",
              {
                ref: "tabs",
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleTabClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _vm.currentRow && _vm.currentRow.containerLoadType === "TT"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabGatheringTrailerBase",
                          label: _vm.$t("SeaExport.Basic")
                        }
                      },
                      [
                        _c("tab-gathering-trailer-base", {
                          ref: "tabGatheringTrailerBase",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow && _vm.currentRow.containerLoadType === "CL"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabLessThanCarloadBase",
                          label: _vm.$t("SeaExport.Basic")
                        }
                      },
                      [
                        _c("tab-less-than-carload-base", {
                          ref: "tabLessThanCarloadBase",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow &&
                !_vm.currentRow.masterFlag &&
                _vm.currentRow.containerLoadType === "IC"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabInternationalCard",
                          label: _vm.$t("CargoMsg.Cargo_IC")
                        }
                      },
                      [
                        _c("tab-international-card-base", {
                          ref: "tabInternationalCard",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow && _vm.currentRow.containerLoadType === "IC"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabOrderCar",
                          label: _vm.$t("CargoMsg.Cargo_Booking")
                        }
                      },
                      [
                        _c("tab-order-car", {
                          ref: "tabOrderCar",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow && _vm.currentRow.containerLoadType === "TT"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabGatheringTrailer",
                          label: _vm.$t("SeaExport.GatheringTrailer")
                        }
                      },
                      [
                        _c("tab-gathering-trailer", {
                          ref: "tabGatheringTrailer",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow && _vm.currentRow.containerLoadType === "CL"
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabLessThanCarload",
                          label: _vm.$t("SeaExport.WholeVehicleLessThanCarload")
                        }
                      },
                      [
                        _c("tab-less-than-carload", {
                          ref: "tabLessThanCarload",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_IEBooking_portalState"],
                        expression: "['tab_IEBooking_portalState']"
                      }
                    ],
                    attrs: {
                      name: "tabSopState",
                      label: _vm.$t("SeaExport.BusinessStatus")
                    }
                  },
                  [
                    _c("tab-sop-state", {
                      ref: "tabSopState",
                      attrs: {
                        context: _vm.context,
                        action: _vm.action,
                        "show-button": _vm.showButton
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      name: "tabFileHistory",
                      label: _vm.$t("SeaExport.FileHistory")
                    }
                  },
                  [
                    _c("tab-file-history", {
                      ref: "tabFileHistory",
                      attrs: {
                        context: _vm.context,
                        action: _vm.action,
                        "show-button": _vm.showButton,
                        "can-operate-job": _vm.canOperateJob
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }